export default __webpack_public_path__ + "static/media/118t.a9f0b366.jpg";